import React from 'react';
import styles from './footer.module.scss';
import LinkedIn from '../../static/images/badges/linkedin.svg';
import Glassdoor from '../../static/images/badges/Glassdoor.svg';
import Img from "gatsby-image";
import Link from 'gatsby-link';


const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.footer__two__column_badge}>
      <div className={styles.footer__two__column__badge__container__box}>
        <a href="https://www.linkedin.com/company/first-walkin-technologies/" target="_blank"><img src={LinkedIn} height = "24px"/></a>
      </div>
      <div className={styles.footer__two__column__badge__container__box}>
        <a href="https://www.glassdoor.co.in/Overview/Working-at-WalkIn-EI_IE2606707.11,17.htm" target="_blank"><img src={Glassdoor} height = "20px"/></a>
      </div>
    </div>
    <p>&copy; 2019 <a href="http://getwalk.in" target="_blank">First Walkin Pvt Ltd</a></p>
    <div className={styles.footer__two__column_badge}>
      <div>
        <Link to="/privacy_policy" className={styles['landing__btn']}><span>Privacy Policy</span></Link>
      </div>
    </div>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js